import { Col, Row, Container, ListGroup, Button } from 'react-bootstrap';
import styles from './press.module.scss';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import SpiritoryInput from '@/components/common/Forms/SpiritoryInput';
import { SpiritoryButton } from '@/components/common/SpiritoryButton';

import janisWilzcura from '../public/images/press/founders/janis/Janis_Wilzcura.jpeg';
import founderJanis from '../public/images/press/founders/janis/founder_janis.jpg';
import founderJanisTwo from '../public/images/press/founders/janis/founder_janis2.jpg';
import ClemensBennier from '../public/images/press/founders/clemens/Clemens_Bennier.webp';
import founderClemens from '../public/images/press/founders/clemens/founder_clemens.jpg';
import founderClemensTwo from '../public/images/press/founders/clemens/founder_clemens2.jpg';

import LinkedinIcon from '../public/images/press/icons/LinkedIn_icon_circle.svg';
import phoneIcon from '../public/images/press/icons/phone.svg';
import letterIcon from '../public/images/press/icons/letter.svg';

import jpgSpiritoryLogo from '../public/images/press/logos/gold-blue/spiritory.jpg';
import pngSpiritoryLogo from '../public/images/press/logos/gold-blue/spiritory.png';
import svgSpiritoryLogo from '../public/images/press/logos/gold-blue/spiritory.svg';
import svgSpiritoryOnlyLogo from '../public/images/press/logos/gold-blue/spiritoryLogo.svg';
import jpgSpiritoryOnlyLogo from '../public/images/press/logos/gold-blue/spiritoryLogo.jpg';
import pngSpiritoryOnlyLogo from '../public/images/press/logos/gold-blue/spiritoryLogo.png';

import jpgSpiritoryLogoBlue from '../public/images/press/logos/blue/spiritory.jpg';
import pngSpiritoryLogoBlue from '../public/images/press/logos/blue/spiritory.png';
import svgSpiritoryLogoBlue from '../public/images/press/logos/blue/spiritory.svg';
import svgSpiritoryOnlyLogoBlue from '../public/images/press/logos/blue/spiritoryLogo.svg';
import jpgSpiritoryOnlyLogoBlue from '../public/images/press/logos/blue/spiritoryLogo.jpg';
import pngSpiritoryOnlyLogoBlue from '../public/images/press/logos/blue/spiritoryLogo.png';

import jpgSpiritoryLogoWhite from '../public/images/press/logos/white/spiritory.jpg';
import pngSpiritoryLogoWhite from '../public/images/press/logos/white/spiritory.png';
import svgSpiritoryLogoWhite from '../public/images/press/logos/white/spiritory.svg';
import svgSpiritoryOnlyLogoWhite from '../public/images/press/logos/white/spiritoryLogo.svg';
import jpgSpiritoryOnlyLogoWhite from '../public/images/press/logos/white/spiritoryLogo.jpg';
import pngSpiritoryOnlyLogoWhite from '../public/images/press/logos/white/spiritoryLogo.png';

import photoOne from '../public/images/press/various/photoOne.jpg';
import photoTwo from '../public/images/press/various/photoTwo.jpg';
import photoThree from '../public/images/press/various/photoThree.jpg';
import photoFour from '../public/images/press/various/photoFour.jpg';
import photoFive from '../public/images/press/various/photoFive.jpg';
import photoSix from '../public/images/press/various/photoSix.jpg';
import photoSeven from '../public/images/press/various/photoSeven.jpg';
import photoEight from '../public/images/press/various/photoEight.jpg';
import photoNine from '../public/images/press/various/photoNine.jpg';
import photoTen from '../public/images/press/various/photoTen.jpg';
import photoEleven from '../public/images/press/various/photoEleven.jpg';
import photoTwelve from '../public/images/press/various/photoTwelve.jpg';
import photoThirteen from '../public/images/press/various/photoThirteen.jpg';
import photoFourteen from '../public/images/press/various/photoFourteen.jpg';
import photoFifteen from '../public/images/press/various/photoFifteen.jpg';
import photoSixteen from '../public/images/press/various/photoSixteen.jpg';
import photoSeventeen from '../public/images/press/various/photoSeventeen.jpg';
import photoEighteen from '../public/images/press/various/photoEighteen.jpg';
import photoNineteen from '../public/images/press/various/photoNineteen.jpg';
import photoTwenty from '../public/images/press/various/photoTwenty.jpg';
import photoTwentyOne from '../public/images/press/various/photoTwentyone.jpg';
import photoTwentyTwo from '../public/images/press/various/photoTwentytwo.jpg';
import photoTwentyThree from '../public/images/press/various/photoTwentythree.jpg';
import photoTwentyFour from '../public/images/press/various/photoTwentyfour.jpg';
import photoTwentyFive from '../public/images/press/various/photoTwentyfive.jpg';

import pionerLab from '../public/images/press/partners/pioneerLab.png';
import fresenius from '../public/images/press/partners/fresenius.png';
import bayStartup from '../public/images/press/partners/BayStartUP.svg';
import munichBussinessSchool from '../public/images/press/partners/MunichBusinessSchool.png';
import Image from '@/components/common/SpiritoryImage';

import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import getBasicStaticSideProps from '@/lib/staticSideProps/getBasicStaticSideProps';
import { PrimaryButton } from '@/components/common/PrimaryButton';
import { validatePressReleaseSignup } from '@/validations/press.validations';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { OtherEnum } from '@/types/translations/OtherEnum';
import doPressReleaseSubscription from '@/api/doPressReleaseSubscription';
import { useRouter } from 'next/router';
import getCanonicalUrl from '@/utilites/seo/get-canonical-url';
import LanguageAlternates from '@/components/seo/LanguageAlternates';

function PressReleaseSignupForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [error, setError] = useState('');
  const { translate } = useTypedTranslation<OtherEnum>('other');

  const handleSubmit = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      setStatus('idle');
      setError('');
      // Simple email validation
      const { email: emailError } = validatePressReleaseSignup(email, translate);

      if (emailError) {
        setError(emailError);
        return;
      }

      await doPressReleaseSubscription(email);

      setStatus('success');
      setError('');
      setEmail('');
    } catch (error) {
      setStatus('error');
      console.error(error);
      setError(translate(OtherEnum['press.unknown_error_while_subscribing']));
    }
  };

  return (
    <div
      className="tw-mx-auto tw-overflow-hidden tw-rounded-3xl tw-border !tw-border-solid tw-border-blue-200 tw-bg-gradient-to-br tw-from-blue-50 tw-to-platinum-gray tw-p-0 tw-shadow-2xl"
      style={{ minWidth: 320 }}
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-bg-white/80 tw-px-8 tw-pb-6 tw-pt-8">
        <div className="tw-mb-4 tw-flex tw-flex-col tw-items-center">
          <div className="tw-mb-2 tw-rounded-full tw-bg-blue-100 tw-p-3">
            <FontAwesomeIcon icon={faCheck} className="tw-text-2xl tw-text-blue-600" />
          </div>
          <h3 className="tw-text-xl tw-font-bold tw-text-blue-900">
            {translate(OtherEnum['press.press_releases_signup'])}
          </h3>
          <p className="tw-mt-1 tw-text-center tw-text-sm tw-text-gray-600">
            {translate(OtherEnum['press.press_releases_signup_description'])}
          </p>
        </div>
        <form onSubmit={handleSubmit} className="tw-flex tw-w-full tw-flex-col tw-gap-4">
          <SpiritoryInput
            type="email"
            label={translate(OtherEnum['press.email_address'])}
            placeholder={translate(OtherEnum['press.email_address'])}
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            disabled={status === 'success'}
            error={error}
            autoComplete="email"
          />
          <PrimaryButton
            type="submit"
            className="tw-mx-auto tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-bg-blue-600 tw-py-3 tw-text-lg tw-font-bold tw-transition-colors hover:tw-bg-blue-700"
            disabled={status === 'success'}
          >
            {status === 'success' ? (
              <>
                <FontAwesomeIcon icon={faCheck} className="tw-text-green-400" />
                {translate(OtherEnum['press.subscribed'])}
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faCheck} className="tw-text-white" />
                {translate(OtherEnum['press.subscribe'])}
              </>
            )}
          </PrimaryButton>
          {status === 'success' && (
            <div className="tw-animate-fade-in tw-mt-2 tw-flex tw-items-center tw-gap-2 tw-text-base tw-font-semibold tw-text-green-600">
              <FontAwesomeIcon icon={faCheck} className="tw-text-lg tw-text-green-500" />
              {translate(OtherEnum['press.thank_you_for_subscribing'])}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default function Press() {
  const router = useRouter();
  const { t } = useTranslation('other');
  const { translate } = useTypedTranslation<OtherEnum>('other');
  const canonicalUrl = getCanonicalUrl(router);
  return (
    <>
      <Head>
        <title>{t('press.meta_title')}</title>
        <link rel="canonical" href={canonicalUrl} />
        <LanguageAlternates />
      </Head>
      <Container className={`pb-6`}>
        <div className={styles.pressContainer}>
          <div className="mb-3">
            <Col>
              <h1>{translationFallback('press.title', t('press.title'), 'We are Spiritory.')}</h1>
            </Col>
          </div>
          <div>
            <h2>
              {translationFallback(
                'press.subtitle',
                t('press.subtitle'),
                'We are revolutionizing the future of the global spirits trade.'
              )}
            </h2>
          </div>
          <div className="mt-5">
            <ListGroup className="d-flex flex-column gap-2">
              <ListGroup.Item className="border-0">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <Button className={styles.pressCheckMarkIcon}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>
                  <p className="m-0">
                    {translationFallback(
                      'press.item1',
                      t('press.item1'),
                      'Spiritory is a unique stock market-like platform that enables trading top-notch spirits at real market prices.'
                    )}
                  </p>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="border-0">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <Button className={styles.pressCheckMarkIcon}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>
                  <p className="m-0">
                    {translationFallback(
                      'press.item2',
                      t('press.item2'),
                      'We aim for equal conditions: Therefore, our stock market approach is not only extremely transparent but also provides buyers and sellers with the same conditions and opportunities.'
                    )}
                  </p>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="border-0">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <Button className={styles.pressCheckMarkIcon}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>
                  <p className="m-0">
                    {translationFallback(
                      'press.item2',
                      t('press.item2'),
                      'Time is one of the most valuable assets we possess. Spiritory takes care of all time-consuming tasks, from listing products, photographing, describing, to managing buyers and sellers. Users should focus on the essential: trading.'
                    )}
                  </p>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="border-0">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <Button className={styles.pressCheckMarkIcon}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>
                  <p className="m-0">
                    {translationFallback(
                      'press.item3',
                      t('press.item3'),
                      'Global counterfeiting is a major concern for users, especially when buying and selling abroad. We have developed an authentication process that ensures every bottle sold is genuine.'
                    )}
                  </p>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="border-0">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <Button className={styles.pressCheckMarkIcon}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                  </div>
                  <p className="m-0">
                    {translationFallback(
                      'press.item4',
                      t('press.item4'),
                      'Our trading system provides users with thousands of relevant data points and performance metrics to support their decision-making process.'
                    )}
                  </p>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </div>
          <div style={{ marginTop: '6rem' }}>
            <div>
              <h2>
                {translationFallback('press.the_founders', 'press.the_founders', 'The founders')}
              </h2>
            </div>

            <div className="d-flex items-center gap-3 max-nine:tw-flex-col">
              <div
                style={{ marginLeft: '0.13rem', marginTop: '1rem', width: 330 }}
                className="d-flex flex-column"
              >
                <Image
                  width={300}
                  height={300}
                  style={{
                    width: 300,
                    height: 300,
                    aspectRatio: '1/1',
                    padding: 0,
                  }}
                  src={janisWilzcura}
                  alt="Janis Wilzcura"
                />
                <p
                  style={{
                    margin: '1rem 0rem',
                    paddingLeft: 0,
                    fontSize: '1.5rem',
                  }}
                >
                  Janis Wilzcura
                </p>
                <p style={{ paddingLeft: 0 }}>
                  {translationFallback(
                    'press.founders.janis.item1',
                    t('press.founders.janis.item1'),
                    'Whisky investor and collector'
                  )}
                  <br />{' '}
                  {translationFallback(
                    'press.founders.janis.item2',
                    t('press.founders.janis.item2'),
                    'Former head of the Commercial-'
                  )}
                  <br />
                  {translationFallback(
                    'press.founders.janis.item3',
                    t('press.founders.janis.item3'),
                    'Department of the Embracer Group, MBA'
                  )}
                  <br />{' '}
                  {translationFallback(
                    'press.founders.janis.item4',
                    t('press.founders.janis.item4'),
                    'at Munich Business School.'
                  )}
                  <br />{' '}
                  {translationFallback(
                    'press.founders.janis.item5',
                    t('press.founders.janis.item5'),
                    'Co-founder of the startup Uptea'
                  )}
                </p>
                <a
                  rel="noreferrer"
                  style={{ width: 'fit-content', paddingLeft: 0 }}
                  href="https://www.linkedin.com/in/janis-wilczura-mba-b1a6009a/"
                  target="_blank"
                  className="mt-1 text-decoration-none"
                >
                  <Image
                    src={LinkedinIcon}
                    alt="Linkedin Icon"
                    width={45}
                    height={45}
                    style={{ borderRadius: '100%' }}
                  />
                </a>
              </div>
              <div
                style={{ marginLeft: '0.13rem', marginTop: '1rem', width: 330 }}
                className="d-flex flex-column"
              >
                <Image
                  width={300}
                  height={300}
                  style={{
                    width: 300,
                    height: 300,
                    aspectRatio: '1/1',
                    padding: 0,
                  }}
                  src={ClemensBennier}
                  alt="Clemens Bennier"
                />
                <p
                  style={{
                    margin: '1rem 0rem',
                    paddingLeft: 0,
                    fontSize: '1.5rem',
                  }}
                >
                  Clemens Bennier
                </p>
                <p style={{ paddingLeft: 0 }}>
                  {translationFallback(
                    'press.founders.clemens.item1',
                    t('press.founders.clemens.item1'),
                    'Rum and beer enthusiast. Supports friends in brewing beer as a hobby.'
                  )}
                  <br />
                  {translationFallback(
                    'press.founders.clemens.item2',
                    t('press.founders.clemens.item2'),
                    'Technical team leader and entrepreneur'
                  )}
                  <br />
                  {translationFallback(
                    'press.founders.clemens.item3',
                    t('press.founders.clemens.item3'),
                    'in the field of IT, marketing & social media content creation.'
                  )}
                </p>
                <a
                  style={{ width: 'fit-content', paddingLeft: 0 }}
                  href="https://www.linkedin.com/in/clemens-oliver-bennier-143309144/"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-1 text-decoration-none"
                >
                  <Image
                    src={LinkedinIcon}
                    alt="Linkedin Icon"
                    width={45}
                    height={45}
                    style={{ borderRadius: '100%' }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '6rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <h2>
                {translationFallback(
                  'press.global_idea.title',
                  'press.global_idea.title',
                  'The beginning of a truly global idea.'
                )}
              </h2>
            </div>
            <div className="d-flex flex-column gap-2">
              <p>
                {translationFallback(
                  'press.global_idea.p1',
                  t('press.global_idea.p1'),
                  'Our story begins with a motivation and a problem. When Janis Wilczura traveled to Japan in 2016, he remembered a friend telling him that Japanese whisky was a good investment opportunity. So, he tried it out and bought a Japan-exclusive whisky from a newly opened brand, bringing the bottle back to Germany.'
                )}
              </p>
              <p>
                {translationFallback(
                  'press.global_idea.p2',
                  t('press.global_idea.p2'),
                  'Three years later, Janis was interested in purchasing a special Scotch malt, but before that, he needed some money. Thus, he wanted to sell the Japanese whisky he had bought in Japan. However, at that moment, Janis realized that he had no idea how to sell his bottle.'
                )}
              </p>
              <p>
                {translationFallback(
                  'press.global_idea.p3',
                  t('press.global_idea.p3'),
                  'After endless hours of internet research, he discovered that there was no trading platform for the investment class of whisky. So, he attempted to sell his bottle on the secondary market. Yet, he was immediately frustrated; the first platform provided him with an unrealistic price feedback, the second platform left him with an endless stream of work, and the third platform only allowed trading within Germany. At this point, he realized that in a world where you can buy and sell stocks and cryptocurrencies within seconds, there was a lack of a home for trading whisky'
                )}
              </p>
              <p>
                {translationFallback(
                  'press.global_idea.p4',
                  t('press.global_idea.p4'),
                  'The idea for Spiritory was born. A genuine trading platform for blue-chip spirits, with the mission to empower a global audience to access transparent price and performance data and intelligent technology that makes trading as straightforward as possible.'
                )}
              </p>
              <p>
                {translationFallback(
                  'press.global_idea.p5',
                  t('press.global_idea.p5'),
                  'At the beginning of 2022, Janis founded Spiritory GmbH together with Clemens.'
                )}
              </p>
            </div>
          </div>
          <div style={{ marginTop: '6rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <h2>
                {translationFallback(
                  'press.press_download',
                  'press.press_download',
                  'Press Download'
                )}
              </h2>
            </div>
            <p style={{ margin: '1rem 0rem', fontSize: '1.5rem' }}>
              {translationFallback('press.logos', t('press.logos'), 'Logos')}
            </p>
            <div className="d-flex align-items-start flex-column gap-4">
              <div
                className={`d-flex align-items-center justify-content-between max-nine:tw-flex-col ${styles.pressLogos}`}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={jpgSpiritoryLogo.src}
                  className={`d-flex flex-column text-center ${styles.pressLogosLink}`}
                >
                  <Image
                    src={jpgSpiritoryLogo}
                    alt="Spiritory Logo jpg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .jpg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={pngSpiritoryLogo.src}
                  className={`d-flex flex-column text-center ${styles.pressLogosLink}`}
                >
                  <Image
                    src={pngSpiritoryLogo}
                    alt="Spiritory Logo png"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .png
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={svgSpiritoryLogo.src}
                  className={`d-flex flex-column text-center ${styles.pressLogosLink}`}
                >
                  <Image
                    src={svgSpiritoryLogo}
                    alt="Spiritory Logo svg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .svg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={jpgSpiritoryOnlyLogo.src}
                  style={{ width: 100 }}
                  className={`d-flex flex-column text-center ${styles.pressLogosLinkOnlyLogo}`}
                >
                  <Image
                    src={jpgSpiritoryOnlyLogo}
                    alt="Spiritory icon jpg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .jpg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={pngSpiritoryOnlyLogo.src}
                  style={{ width: 100 }}
                  className={`d-flex flex-column text-center ${styles.pressLogosLinkOnlyLogo}`}
                >
                  <Image
                    src={pngSpiritoryOnlyLogo}
                    alt="Spiritory icon png"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .png
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={svgSpiritoryOnlyLogo.src}
                  style={{ width: 100 }}
                  className={`d-flex flex-column text-center ${styles.pressLogosLinkOnlyLogo}`}
                >
                  <Image
                    src={svgSpiritoryOnlyLogo}
                    alt="Spiritory icon svg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .svg
                    </p>
                  </div>
                </a>
              </div>
              <div
                className={`d-flex align-items-center justify-content-between max-nine:tw-flex-col ${styles.pressLogos}`}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={jpgSpiritoryLogoBlue.src}
                  className={`d-flex flex-column text-center ${styles.pressLogosLink}`}
                >
                  <Image
                    src={jpgSpiritoryLogoBlue}
                    alt="Spiritory Logo blue jpg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .jpg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={pngSpiritoryLogoBlue.src}
                  className={`d-flex flex-column text-center ${styles.pressLogosLink}`}
                >
                  <Image
                    src={pngSpiritoryLogoBlue}
                    alt="Spiritory Logo blue png"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .png
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={svgSpiritoryLogoBlue.src}
                  className={`d-flex flex-column text-center ${styles.pressLogosLink}`}
                >
                  <Image
                    src={svgSpiritoryLogoBlue}
                    alt="Spiritory Logo blue svg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .svg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={jpgSpiritoryOnlyLogoBlue.src}
                  style={{ width: 100 }}
                  className={`d-flex flex-column text-center ${styles.pressLogosLinkOnlyLogo}`}
                >
                  <Image
                    src={jpgSpiritoryOnlyLogoBlue}
                    alt="Spiritory icon blue jpg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .jpg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={pngSpiritoryOnlyLogoBlue.src}
                  style={{ width: 100 }}
                  className={`d-flex flex-column text-center ${styles.pressLogosLinkOnlyLogo}`}
                >
                  <Image
                    src={pngSpiritoryOnlyLogoBlue}
                    alt="Spiritory icon blue png"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .png
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={svgSpiritoryOnlyLogoBlue.src}
                  style={{ width: 100 }}
                  className={`d-flex flex-column text-center ${styles.pressLogosLinkOnlyLogo}`}
                >
                  <Image
                    src={svgSpiritoryOnlyLogoBlue}
                    alt="Spiritory icon blue svg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="text-white m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .svg
                    </p>
                  </div>
                </a>
              </div>
              <div
                className={`d-flex align-items-center justify-content-between max-nine:tw-flex-col ${styles.pressLogosWhite}`}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={jpgSpiritoryLogoWhite.src}
                  className={`text-decoration-none d-flex flex-column text-center ${styles.pressLogosLinkWhite}`}
                >
                  <Image
                    src={jpgSpiritoryLogoWhite}
                    alt="Spiritory logo white jpg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .jpg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={pngSpiritoryLogoWhite.src}
                  className={`text-decoration-none d-flex flex-column text-center ${styles.pressLogosLinkWhite}`}
                >
                  <Image
                    src={pngSpiritoryLogoWhite}
                    alt="Spiritory logo white png"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .png
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={svgSpiritoryLogoWhite.src}
                  className={`text-decoration-none d-flex flex-column text-center ${styles.pressLogosLinkWhite}`}
                >
                  <Image
                    src={svgSpiritoryLogoWhite}
                    alt="Spiritory logo white svg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .svg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={jpgSpiritoryOnlyLogoWhite.src}
                  className={`text-decoration-none d-flex flex-column text-center ${styles.pressLogosLinkWhiteOnlyLogo}`}
                >
                  <Image
                    src={jpgSpiritoryOnlyLogoWhite}
                    alt="Spiritory icon white jpg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .jpg
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={pngSpiritoryOnlyLogoWhite.src}
                  className={`text-decoration-none d-flex flex-column text-center ${styles.pressLogosLinkWhiteOnlyLogo}`}
                >
                  <Image
                    src={pngSpiritoryOnlyLogoWhite}
                    alt="Spiritory icon white png"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .png
                    </p>
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={svgSpiritoryOnlyLogoWhite.src}
                  className={`text-decoration-none d-flex flex-column text-center ${styles.pressLogosLinkWhiteOnlyLogo}`}
                >
                  <Image
                    src={svgSpiritoryOnlyLogoWhite}
                    alt="Spiritory icon white svg"
                    width={800}
                    height={800}
                    className=""
                  />
                  <div
                    style={{ height: '25%' }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <p className="m-0 p-0 d-flex" style={{ height: 'fit-content' }}>
                      .svg
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <p style={{ margin: '1.5rem 0rem 1rem 0', fontSize: '1.5rem' }}>
              {translationFallback('press.the_founders', t('press.the_founders'), 'The founders')}
            </p>
            <div className="d-flex items-center gap-6 max-nine:tw-flex-col">
              <div>
                <p
                  style={{
                    margin: '0rem 0rem 0.5rem 0rem',
                    fontSize: '1.2rem',
                  }}
                >
                  Janis Wilczura
                </p>
                <div className="d-flex align-items-center gap-3">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={founderJanisTwo.src}
                    style={{ width: 200 }}
                  >
                    <Image
                      src={founderJanisTwo}
                      alt="Janis Wilzcura"
                      width={300}
                      height={300}
                      style={{ width: '100%' }}
                    />
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={founderJanis.src}
                    style={{ width: 200 }}
                  >
                    <Image
                      src={founderJanis}
                      alt="Janis Wilzcura"
                      width={300}
                      height={300}
                      style={{ width: '100%' }}
                    />
                  </a>
                </div>
              </div>
              <div>
                <p
                  style={{
                    margin: '0rem 0rem 0.5rem 0rem',
                    fontSize: '1.2rem',
                  }}
                >
                  Clemens Bennier
                </p>
                <div className="d-flex align-items-center gap-3">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={founderClemens.src}
                    style={{ width: 200 }}
                  >
                    <Image
                      src={founderClemens}
                      alt="Clemens Bennier"
                      width={300}
                      height={300}
                      style={{ width: '100%' }}
                    />
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={founderClemensTwo.src}
                    style={{ width: 200 }}
                  >
                    <Image
                      src={founderClemensTwo}
                      alt="Clemens Bennier"
                      width={300}
                      height={300}
                      style={{ width: '100%' }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <p style={{ margin: '1.5rem 0rem', fontSize: '1.5rem' }}>
              {translationFallback(
                'press.photos_various',
                t('press.photos_various'),
                'Photos (various)'
              )}
            </p>
            <div className={`d-flex flex-column gap-3 ${styles.hideSmall}`}>
              <div className="d-flex gap-3">
                <a href={photoOne.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoOne}
                    alt="various one"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoTwo.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoTwo}
                    alt="various two"
                    width={100}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoThree.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoThree}
                    alt="various three"
                    width={100}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFour.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoFour}
                    alt="various four"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFive.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoFive}
                    alt="various five"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
              <div className="d-flex gap-3">
                <a href={photoSix.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoSix}
                    alt="various six"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoSeven.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoSeven}
                    alt="various seven"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoNine.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoNine}
                    alt="various nine"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoTen.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoTen}
                    alt="various ten"
                    width={120}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFifteen.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoFifteen}
                    alt="various fifteen"
                    width={120}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
              <div className="d-flex gap-3">
                <a href={photoEleven.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoEleven}
                    alt="various eleven"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoTwelve.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoTwelve}
                    alt="various twelve"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoThirteen.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoThirteen}
                    alt="various thirteen"
                    width={120}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFourteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoFourteen}
                    alt="various fourteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
              <div className="d-flex gap-3">
                <a href={photoSixteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoSixteen}
                    alt="various sixteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoSeventeen.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoSeventeen}
                    alt="various seventeen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoEighteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoEighteen}
                    alt="various eighteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoNineteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoNineteen}
                    alt="various nineteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
              <div className="d-flex gap-3">
                <a href={photoTwenty.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoTwenty}
                    alt="various twenty"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyOne.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyOne}
                    alt="various twenty one"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyTwo.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyTwo}
                    alt="various twenty two"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
              <div className="d-flex gap-3">
                <a
                  href={photoTwentyThree.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyThree}
                    alt="Janis Wilzcura & Clemens Bennier"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyFour.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyFour}
                    alt="Janis Wilzcura & Clemens Bennier"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyFive.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyFive}
                    alt="Janis Wilzcura & Clemens Bennier"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
            </div>
            {/* smaller screens */}
            <div className={`d-flex flex-column gap-3 ${styles.hideLarge}`}>
              <div className="d-flex gap-3 flex-wrap">
                <a href={photoOne.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoOne}
                    alt="various one"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoTwo.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoTwo}
                    alt="various two"
                    width={100}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoThree.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoThree}
                    alt="various three"
                    width={100}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFour.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoFour}
                    alt="various four"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFive.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoFive}
                    alt="various five"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>

                <a href={photoSix.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoSix}
                    alt="various six"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoSeven.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoSeven}
                    alt="various seven"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoEight.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoEight}
                    alt="various eight"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoNine.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoNine}
                    alt="various nine"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoTen.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoTen}
                    alt="various ten"
                    width={120}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>

                <a href={photoEleven.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoEleven}
                    alt="various eleven"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoTwelve.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoTwelve}
                    alt="various twelve"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoThirteen.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoThirteen}
                    alt="various thirteen"
                    width={120}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFourteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoFourteen}
                    alt="various fourteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoFifteen.src} target="_blank" rel="noreferrer" style={{ width: 120 }}>
                  <Image
                    src={photoFifteen}
                    alt="various fifteen"
                    width={120}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>

                <a href={photoSixteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoSixteen}
                    alt="various sixteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoSeventeen.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoSeventeen}
                    alt="various seventeen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoEighteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoEighteen}
                    alt="various eighteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a href={photoNineteen.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoNineteen}
                    alt="various nineteen"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>

                <a href={photoTwenty.src} target="_blank" rel="noreferrer" style={{ width: 250 }}>
                  <Image
                    src={photoTwenty}
                    alt="various twenty"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyOne.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyOne}
                    alt="various twenty one"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyTwo.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyTwo}
                    alt="various twenty two"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>

                <a
                  href={photoTwentyThree.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyThree}
                    alt="various twenty three"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyFour.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyFour}
                    alt="various twenty four"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
                <a
                  href={photoTwentyFive.src}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: 250 }}
                >
                  <Image
                    src={photoTwentyFive}
                    alt="various twenty five"
                    width={250}
                    height={170}
                    style={{ width: '100%', height: '170.08px' }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '6rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <h2>
                {translationFallback(
                  'press.our_partners_and_supporters',
                  t('press.our_partners_and_supporters'),
                  'Our Partners and Supporters'
                )}
              </h2>
            </div>
            <div className={`d-flex gap-3 max-nine:tw-flex-col ${styles.supporters}`}>
              <div>
                <Image src={pionerLab} alt="Pioner Lab" width={300} height={300} />
              </div>
              <div>
                <Image src={fresenius} alt="Fresenius" width={300} height={300} />
              </div>
              <div>
                <Image src={bayStartup} alt="BayStartup" width={300} height={300} />
              </div>
              <div>
                <Image
                  src={munichBussinessSchool}
                  alt="Munich Business School"
                  width={300}
                  height={300}
                />
              </div>
            </div>
          </div>
          <div
            style={{ marginTop: '6rem' }}
            className="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-gap-12"
          >
            <div>
              <div style={{ marginBottom: '1rem' }}>
                <h2>
                  {translationFallback(
                    'press.do_you_have_any_questions',
                    t('press.do_you_have_any_questions'),
                    'Do you have any questions?'
                  )}
                </h2>
              </div>
              <p style={{ margin: '1rem 0rem', fontSize: '1.5rem' }}>
                {translationFallback(
                  'press.contact_person',
                  t('press.contact_person'),
                  'Contact Person'
                )}
              </p>
              <Image
                width={800}
                height={800}
                style={{
                  width: 250,
                  height: 250,
                  padding: 0,
                  marginLeft: '12px',
                }}
                src={janisWilzcura}
                alt="Janis Wilzcura"
              />
              <div className="mt-4 d-flex flex-column gap-2">
                <strong style={{ fontSize: '1.5rem' }}>Janis Wilzcura</strong>
                <div className="d-flex flex-column gap-2">
                  <a
                    href="mailto:janis@spiritory.com"
                    className="text-decoration-none d-flex align-items-center gap-2"
                  >
                    <Image src={letterIcon} alt="letter Icon" width={25} height={25} />
                    <p className="m-0">janis [at] spiritory.com</p>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <PressReleaseSignupForm />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export const getStaticProps = getBasicStaticSideProps(['common', 'other', 'index']);
